import { Box } from '@chakra-ui/layout'
import { IconButton } from '@chakra-ui/button'

import { FiEye } from 'react-icons/fi'
import { useDisclosure } from '@chakra-ui/react'
import { Modal } from './Modal'

type ModalShowAccreditedProps = {
  original: {}
}

export function ModalShowAccredited({ original }: ModalShowAccreditedProps) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box>
      <Modal original={original} isOpen={isOpen} onClose={onClose} />
      <IconButton
        aria-label="Visualizar"
        icon={<FiEye />}
        background="transparent"
        _hover={{
          background: 'transparent',
          color: 'blue',
        }}
        onClick={() => onOpen()}
      />
    </Box>
  )
}
